<template>
    <div class="container-xxl">
        <div class="row justify-content-center">
            <div class="col-12 col-md-10 col-xl-9 col-xxl-8">
                <div class="row justify-content-between padding-container-xs">
                    <div class="col-12 col-md-6 mb-4 mb-md-0">
                        <router-link
                            v-if="$route.name === 'blogue-publication-fr'"
                            :to="{ name: 'blogue-fr' }"
                            class="link-arrow left bold text-uppercase text-red mb-0"
                            itemtype="https://www.schema.org/SiteNavigationElement"
                        >
                            {{ $t('Retour au blogue') }}
                        </router-link>
                        <router-link
                            v-else
                            :to="{ name: 'Nouvelles-fr' }"
                            class="link-arrow left bold text-uppercase text-red mb-0"
                            itemtype="https://www.schema.org/SiteNavigationElement"
                        >
                            {{ $t('Retour aux nouvelles') }}
                        </router-link>
                    </div>

                    <div class="col-12 col-md-auto d-flex align-items-center">
                        <span class="text-small me-4">{{ $t('Partagez') }}</span>
                        <ShareLinks />
                    </div>
                </div>

                <div
                    v-if="content.featuredImage"
                    class="row"
                    data-aos="fade-up"
                    data-aos-offset="-800"
                    data-aos-delay="1000"
                >
                    <div class="col-12">
                        <img
                            class="main-search-image"
                            :src="content.featuredImage.img.url"
                            :alt="content.featuredImage.img.title"
                        />
                    </div>
                </div>

                <div class="row row-news-meta g-lg-0">
                    <div class="col-12 col-lg-7 order-2 order-lg-1">
                        <div class="title-wrapper">
                            <!-- Headings -->
                            <div v-if="content.titleEditorStyle">
                                <h4 class="main-search-title mb-4 styled bold" v-html="removeP(content.titleEditorStyle)"></h4>
                            </div>
                            <div v-else>
                                <h4 class="main-search-title mb-4 bold" v-html="content.title"></h4>
                            </div>

                            <p class="date">{{ thePostDate(content.postDate.date) }}</p>
                        </div>
                    </div>

                    <div
                        v-if="content.featuredImage.img.imgCredits"
                        class="col-12 col-lg-5 order-1 order-lg-2"
                    >
                        <div
                            class="credit-wrapper image-credit"
                            v-html="content.featuredImage.img.imgCredits"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ShareLinks from '@/components/Parts/ShareLinks'
import dayjs from 'dayjs'
export default {
    name: 'HeroNewsSingle',

    components: {
        // AssetLoader,
        ShareLinks,
    },

    // On loaded...
    mounted() {},

    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['content']),
    },
    methods: {
        thePostDate(actualDate) {
            var date = new Date(actualDate)
            return dayjs(date).format('dddd D MMMM YYYY')
        },
        removeP(str) {
            const newString = str.replace('<p>', "");
            return newString.replace('</p>', "");
        },
    },
}
</script>
